/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Listing_Extra_Info_HintInputs */

const cs_portals_listing_extra_info_hint = /** @type {(inputs: Portals_Listing_Extra_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jen štítek Sreality (Rezervováno / Prodáno) — není to Skrýt na webu. CRM stav nechte Aktivní.`)
};

const en_portals_listing_extra_info_hint = /** @type {(inputs: Portals_Listing_Extra_Info_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sreality badge only (Reserved / Sold) — not website Unpublish. Keep CRM status Active.`)
};

/**
* | output |
* | --- |
* | "Sreality badge only (Reserved / Sold) — not website Unpublish. Keep CRM status Active." |
*
* @param {Portals_Listing_Extra_Info_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_listing_extra_info_hint = /** @type {((inputs?: Portals_Listing_Extra_Info_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Listing_Extra_Info_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_listing_extra_info_hint(inputs)
	return cs_portals_listing_extra_info_hint(inputs)
});